/* ============================================================
   Custom Size Finder — Son of Son
   Global event-delegated controller for the size-guide drawer.
   Works on PDP AND inside the Quick Buy modal (PhotoSwipe injects
   the section via innerHTML, so inline <script> tags don't run —
   that's why this is loaded as an external asset globally).

   Markup contract (rendered by snippets/custom-size-finder.liquid):
     .size-finder[data-chart-type="slim|oversize|pants"]
       [data-size-finder-open]              → opens drawer
       .size-finder__backdrop[data-size-finder-close]
       .size-finder__drawer
         [data-size-finder-close]           → closes drawer
         [data-size-finder-form]
           input[type=range][data-sync="altura|peso"]
           input[type=hidden][data-input="altura|peso"]
           [data-display="altura|peso"]
           [data-size-finder-submit]
         [data-size-finder-result][hidden]
           [data-result-size]
           [data-result-note]
   ============================================================ */

(function () {
  if (window.__sofsSizeFinderInit) return;
  window.__sofsSizeFinderInit = true;

  const TABLES = {
    slim:     { sizes: ['S','M','L','XL'],         alturaMax: [173, 178, 184, 999], pesoMax: [65, 75, 87, 999] },
    oversize: { sizes: ['XS','S','M','L','XL'],    alturaMax: [165, 172, 180, 188, 999], pesoMax: [58, 68, 78, 90, 999] },
    pants:    { sizes: ['S','M','L','XL'],         alturaMax: [172, 180, 188, 999], pesoMax: [68, 78, 90, 999] },
  };
  const NOTES = {
    slim:     'Camisetas Slim Fit · Queda ajustado al cuerpo.',
    oversize: 'Fit relajado · Queda holgado, como debe ser.',
    pants:    'Pantalón regular · Ajuste cómodo en cintura y pierna.',
  };

  function calcSize(chart, altura, peso) {
    const t = TABLES[chart];
    if (!t) return null;
    let aIdx = t.sizes.length - 1;
    for (let i = 0; i < t.alturaMax.length; i++) {
      if (altura <= t.alturaMax[i]) { aIdx = i; break; }
    }
    let pIdx = t.sizes.length - 1;
    for (let i = 0; i < t.pesoMax.length; i++) {
      if (peso <= t.pesoMax[i]) { pIdx = i; break; }
    }
    return t.sizes[Math.max(aIdx, pIdx)];
  }

  /* Teleport the drawer + backdrop out of the finder container and into <body>.
     This escapes any ancestor with transform/filter/perspective (which create
     a containing block for position:fixed). PhotoSwipe modals always have a
     transformed ancestor (.pswp__zoom-wrap), so without this the drawer would
     render inline with position:fixed acting like position:absolute. */
  function teleport(finder) {
    if (finder.dataset.teleported === '1') return;
    const backdrop = finder.querySelector('.size-finder__backdrop');
    const drawer   = finder.querySelector('.size-finder__drawer');
    if (!backdrop || !drawer || !document.body) return;

    // Wipe orphaned drawers from previous quickview opens (different products)
    document.body.querySelectorAll(
      '.size-finder__drawer[data-sofs-teleport], .size-finder__backdrop[data-sofs-teleport]'
    ).forEach(el => { if (!el.classList.contains('is-open')) el.remove(); });

    backdrop.setAttribute('data-sofs-teleport', '1');
    drawer.setAttribute('data-sofs-teleport', '1');
    document.body.appendChild(backdrop);
    document.body.appendChild(drawer);
    finder.dataset.teleported = '1';
    finder._sofsBackdrop = backdrop;
    finder._sofsDrawer = drawer;
  }

  function getDrawer(finder) {
    return finder._sofsDrawer || finder.querySelector('.size-finder__drawer');
  }
  function getBackdrop(finder) {
    return finder._sofsBackdrop || finder.querySelector('.size-finder__backdrop');
  }

  function openFinder(finder) {
    teleport(finder);
    const drawer = getDrawer(finder);
    const backdrop = getBackdrop(finder);
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('size-finder-open');
    setTimeout(() => { try { drawer.focus({ preventScroll: true }); } catch (_) {} }, 50);
  }
  function closeFinder(drawer) {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    // The associated backdrop lives next to the drawer in <body>
    document.querySelectorAll('.size-finder__backdrop.is-open').forEach(b => b.classList.remove('is-open'));
    document.documentElement.classList.remove('size-finder-open');
  }
  function closeAll() {
    document.querySelectorAll('.size-finder__drawer.is-open').forEach(closeFinder);
  }

  /* ---------- delegated event listeners ---------- */

  document.addEventListener('click', (e) => {
    // Open
    const opener = e.target.closest('[data-size-finder-open]');
    if (opener) {
      const finder = opener.closest('.size-finder');
      if (finder) {
        e.preventDefault();
        openFinder(finder);
      }
      return;
    }
    // Close (close button OR backdrop)
    const closer = e.target.closest('[data-size-finder-close]');
    if (closer) {
      e.preventDefault();
      // Close all open drawers — only one is ever expected open at a time
      closeAll();
      return;
    }
    // Submit calculator
    const submit = e.target.closest('[data-size-finder-submit]');
    if (submit) {
      e.preventDefault();
      e.stopPropagation();
      const drawer = submit.closest('.size-finder__drawer');
      if (!drawer) return;
      const chart = drawer.dataset.chartType;
      const alturaInput = drawer.querySelector('[data-input="altura"]');
      const pesoInput   = drawer.querySelector('[data-input="peso"]');
      const altura = parseInt(alturaInput?.value || '170', 10);
      const peso   = parseInt(pesoInput?.value   || '70', 10);
      const size = calcSize(chart, altura, peso);
      const result = drawer.querySelector('[data-size-finder-result]');
      const resultSize = drawer.querySelector('[data-result-size]');
      const resultNote = drawer.querySelector('[data-result-note]');
      if (size && result && resultSize && resultNote) {
        resultSize.textContent = size;
        resultNote.textContent = NOTES[chart] || '';
        result.hidden = false;
        requestAnimationFrame(() => {
          result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      }
    }
  });

  document.addEventListener('input', (e) => {
    const range = e.target.closest('[data-sync]');
    if (!range) return;
    const drawer = range.closest('.size-finder__drawer');
    if (!drawer) return;
    const name = range.dataset.sync;
    const display = drawer.querySelector(`[data-display="${name}"]`);
    const hidden  = drawer.querySelector(`[data-input="${name}"]`);
    if (display) display.textContent = range.value;
    if (hidden)  hidden.value = range.value;
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && document.querySelector('.size-finder__drawer.is-open')) {
      closeAll();
    }
  });

  /* Cleanup teleported drawers when the PhotoSwipe Quick Buy modal closes,
     otherwise multiple stale drawers stack up in <body> across opens. */
  document.addEventListener('theme:popup:close', () => {
    document.body.querySelectorAll(
      '.size-finder__drawer[data-sofs-teleport]:not(.is-open), .size-finder__backdrop[data-sofs-teleport]:not(.is-open)'
    ).forEach(el => el.remove());
  });
  document.addEventListener('theme:scroll:unlock', () => {
    // Belt-and-braces: also clean up when PhotoSwipe releases the scroll lock,
    // which fires reliably on every modal close path.
    setTimeout(() => {
      if (document.querySelector('.size-finder__drawer.is-open')) return;
      document.body.querySelectorAll(
        '.size-finder__drawer[data-sofs-teleport], .size-finder__backdrop[data-sofs-teleport]'
      ).forEach(el => el.remove());
    }, 100);
  });
})();
